<template>
  <div class="form-textarea-element-wrapper">
    <FormLabel
      :element="element"
      :labelStyle="labelStyle"
      :fieldStyle="fieldStyle"
    />
    <FormDescription :element="element" :labelStyle="labelStyle" />

    <div class="textarea-field-wrapper position-relative">
      <textarea
        :style="fieldStyle"
        class="form-textarea fw-normal fs-6 w-100 bg-transparent"
        :class="{ 'user-select-none': isDisabled }"
        :id="`textarea-${element.id}`"
        :name="element.name"
        :value="inputValue"
        :required="isRequired"
        :disabled="isDisabled"
        :placeholder="getPlaceholder"
        :rows="textareaRows"
        @input="onHandleInput"
        @change="onHandleChange"
        @invalid="onHandleInvalid"
      ></textarea>
      <img
        class="error-icon position-absolute top-0"
        :src="require('@/assets/img/error-circle-exclamation.svg')"
      />
    </div>
  </div>
</template>

<script>
import { DEFAULT_FORM_STYLES } from '@/utils/constants/WorkFlowConstants';
import { showInputInvalidCustomMessage } from '@/utils/helpers';

import FormLabel from '@/components/FormBuilder/core/FormLabel.vue';
import FormDescription from '@/components/FormBuilder/core/FormDescription.vue';

export default {
  name: 'FormTextareaElement',
  props: {
    element: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    labelStyle: { type: Object, default: () => {} },
    fieldStyle: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    getPlaceholder() {
      return this.element.settings.placeholder || '';
    },
    isRequired() {
      return this.element.settings.required || false;
    },
    isDisabled() {
      return this.disabled || this.element.settings.disabled;
    },
    placeholderStyle() {
      return {
        color:
          this.fieldStyle?.placeholderColor ||
          DEFAULT_FORM_STYLES.placeHolderColor,
        fontFamily:
          this.fieldStyle.fontFamily || DEFAULT_FORM_STYLES.placeholderFont,
      };
    },
    inputTextColor() {
      return this.fieldStyle?.textColor || DEFAULT_FORM_STYLES.inputColor;
    },
    textareaRows() {
      return this.element.settings?.rows || 5;
    },
  },
  methods: {
    onHandleInput(event) {
      this.onHandleInvalid(event);
      this.inputValue = event.target.value;
    },
    onHandleChange() {
      this.$emit('change');
    },
    onHandleInvalid(event) {
      showInputInvalidCustomMessage(event);
    },
  },
  components: {
    FormLabel,
    FormDescription,
  },
};
</script>

<style scoped>
.form-textarea-element-wrapper .form-textarea {
  min-height: 120px;
  font-family: 'OpenSans-Regular';
  border: 0.7px solid #dddddd;
  border-radius: 10px;
  padding: 18px 23px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: v-bind(inputTextColor);
  resize: vertical;
}

.form-textarea-element-wrapper .form-textarea::placeholder {
  font-weight: 600;
  font-family: v-bind('placeholderStyle.fontFamily');
  color: v-bind('placeholderStyle.color');
}

.form-textarea-element-wrapper textarea:focus::placeholder {
  color: transparent !important;
}

.form-textarea-element-wrapper textarea:-webkit-autofill {
  box-shadow: 0 0 0 1000px white inset !important;
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
  -webkit-text-fill-color: v-bind(inputTextColor);
}

.form-textarea-element-wrapper textarea:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  color: #c5c5c5 !important;
  border-color: #ededed !important;
}

.form-textarea-element-wrapper textarea:focus {
  box-shadow: none;
  border-color: transparent !important;
  outline: 2.2px solid #000000;
  outline-offset: -2.2px;
}

.form-textarea-element-wrapper .textarea-field-wrapper img.error-icon {
  right: 25px;
  transform: translateY(100%);
  cursor: pointer;
  color: #ff0000;
  width: 21px;
  height: 21px;
  display: none;
  user-drag: none;
  -webkit-user-drag: none;
}

.was-submitted
  .form-textarea-element-wrapper:has(.form-textarea:invalid)
  img.error-icon {
  display: block;
  top: auto;
  bottom: 15px;
}

.was-submitted .form-textarea-element-wrapper .form-textarea:invalid {
  outline: 2.2px solid #ff0000 !important;
  background-color: #ff000008;
  border-color: transparent !important;
  outline-offset: -2.2px;
}
</style>
